import { Youtube } from "lucide-react";
import useReveal from "@/hooks/useReveal";

const VIDEOS = [
  { id: "ja65gT7r0BE", title: "Computer Institute Ads", desc: "High converting AI ad creative" },
  { id: "kDnFy7Ry0c8", title: "Paramedical Institute Ads", desc: "High converting AI ad creative" },
  { id: "vImrbmm1iBo", title: "Waterproofing Services Ads", desc: "High converting AI ad creative" },
];

export default function VideoShowcase() {
  const ref = useReveal();
  return (
    <section
      id="ad-creatives"
      ref={ref}
      data-testid="video-showcase-section"
      className="py-16 sm:py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14 fade-up">
          <span className="gmb-badge-yellow">Our Work</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#B01116]">
            High Converting AI Ads Creative
          </h2>
          <p className="mt-5 text-base text-gray-600 leading-relaxed">
            Real ad creatives produced for our clients — engineered with AI to stop
            the scroll and drive sales.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {VIDEOS.map((v, i) => (
            <div
              key={v.id}
              data-testid={`video-card-${i}`}
              className="gmb-card fade-up"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="aspect-video w-full">
                <iframe
                  src={`https://www.youtube.com/embed/${v.id}`}
                  title={v.title}
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full border-0"
                />
              </div>
              <div className="p-5">
                <h3
                  data-testid={`video-title-${i}`}
                  className="font-accent font-bold text-gray-900 text-base"
                >
                  {v.title}
                </h3>
                <p className="text-xs text-gray-500 mt-1">{v.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center fade-up">
          <a
            href="https://www.youtube.com/@goldmindbusinessofficial/playlists"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="view-all-videos-button"
            className="btn-gold gap-2"
          >
            <Youtube className="h-5 w-5" />
            View All Videos
          </a>
        </div>
      </div>
    </section>
  );
}
